import { connect } from 'react-redux';
import CRUDAction from '../../../actions/competition';
import CompetitionsNew from './CompetitionsNew';

export default connect(
  ({competition: { model }}) => ({
    title: 'Create Competition',
    loading: false,
    model,
    isNew: true,
    initialValues: Object.assign({}, model),
  }),
  dispatch => ({
    init: () => dispatch(CRUDAction.createModel())
  })
)(CompetitionsNew);





// WEBPACK FOOTER //
// ./src/components/Competitions/CompetitionsNew/index.js